import React from "react";
import { connect } from "react-redux";
import { setGif } from "../../../../actions/gameChat";
import storage from "../../../../Storage";
import { SITE, GIPHY_API } from "../../../../Helper";
import axios from "axios";
import { MdGifBox } from "react-icons/md";

class Gif extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false
        }
    }

    handleClick = (e) => {
        e.preventDefault();
        this.setState({ show: !this.state.show })
    }

    render() {

        let logged = storage.getKey('logged') !== null ? true : false

        return (
            <>

                {logged === true ?
                    <button style={{padding:"0px",marginTop:"0px",marginBottom:"0px",color:'white',fontSize:"18px"}}  className="btn btn-send-chat btn-bldock  mr-1 btn-xs" onClick={this.handleClick}><MdGifBox fontSize={"18px"}/></button>
                    :
                    <button style={{padding:"0px",marginTop:"0px",marginBottom:"0px",color:"white",fontSize:"18px"}}  type="button" className="btn btn-send-chat btn-bldock  mr-1 btn-xs"><i className="mdi mdi-image-area-close font-18" /></button>
                }

                {
                    this.state.show &&
                    <div className="gif-container animated fadeInUp pl-3">
                        <GifList clicked={this.handleClick} props={this.props} />
                    </div>
                }

            </>
        );
    }
}

class GifList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gifs: []
        }
    }

    componentDidMount() {
        let self = this;

        axios.get(`https://api.giphy.com/v1/gifs/trending`, {
            params: {
                api_key: 'tFT4VlaVegeHXHsKUcX1ObfJoK2NeIwY', // Replace with your actual API key
                limit: 50,
                rating: 'g'
            }
        })
            .then(function (req) {
                let response = req.data;
                let trending = response.data;
                trending.forEach((item, i) => {
                    self.setState(state => ({ gifs: [item, ...state.gifs] }));
                });
            });
    }

    render() {
        const gifs = this.state.gifs.map((item, i) =>
            <MakeGif key={i.toString()} redux={this.props} image={item.images.downsized.url} />
        );
        return gifs;
    }
}

function MakeGif(props) {

    const { image } = props;

    const set = (e) => {
        props.redux.props.setGif(image);
        props.redux.clicked(e);
    }

    return (
        <>
            <img onClick={set} src={image} className={'img-fluid'} alt="GIF" />
        </>
    );
}

export default connect(null, { setGif })(Gif);
